import * as React from 'react';
import {IState as CommonState} from "../../common/State";
import API from "../../common/AxoisClient";
import Lang from "../../common/lang/Lang";
import Swal from "sweetalert2";
import {RouteComponentProps} from "react-router";
import {ListBreadcrumb} from "./Data";
import EmailTemplateFilter from './filter/EmailTemplateFilter';
import _ from "lodash";
import {list_key} from "../../helpers/OrderHelper";
import {ListForm, ListHeader, ListingLayout} from "../../layout/Listing";
import {actionButton, Icons, ShowRecords, CreateLink, EditLink, ExportButton, showNotification} from "../../common";
import {humanifyDate} from "../../helpers/UserHelper";
import { SystemNotificationModel } from '../../model';
import { EmailTemplateDataSchema } from '../email-templates/Model';

declare var window:any;

interface IState extends CommonState {
    UserData: Array<SystemNotificationModel>;
   
}

export class SystemNotifications extends React.Component<RouteComponentProps, IState> {
    state: IState;
    records:React.RefObject<ShowRecords> = React.createRef();

    shouldComponentUpdate(nextProps: Readonly<RouteComponentProps>, nextState: Readonly<IState>, nextContext: any): boolean {
      
        return  this.state !== nextState;
         
     }

    createMarkup =(content: string) => {
        return { __html: content };
    }

    showContent = (data: SystemNotificationModel, index: number) => {
      let cols = [];
      cols.push(...[
        <td key={index}>{this.records.current.checkbox(data.id)}</td>,
        this.records.current.createdTd("title", () =>
          data.title + (data.role_id === 3 ? " (Coach)" : data.role_id === 4 ? " (Player)" : "")
        ),
        this.records.current.createdTd("system_event",
                data.occur_days != null
                ? `${data.system_event.title} (${data.occur_days} days)`
                : data.system_event.title
        ),
        this.records.current.createdTd("recurrence", data.recurrence),
        this.records.current.createdTd("email_templates", () => {
          let email_templates = data.email_templates.map((email_template: EmailTemplateDataSchema) => email_template.name);
         // return this.createMarkup(email_templates.join(", </br>"));
          return <span dangerouslySetInnerHTML={ this.createMarkup(email_templates.join(", </br>")) }/>
        }),
       
        this.records.current.createdTd("status", () => {
          if(data.status === 1){return <span className={'badge badge-primary'}>{Lang.active}</span>;}
          if(data.status === 2){return <span className={'badge badge-warning'}>{Lang.inactive}</span>}
        }),
        this.records.current.createdTd("created_at", humanifyDate(data.created_at)),
        this.records.current.createdTd("action", () => {
          return <div>
            <EditLink scope={'system-notifications.update'} to={`${this.props.match.url}/edit/${data.id}`}  title={"Edit notification"} />
          </div>;
        })
      ]);
      cols = _.compact(cols);
        return (
            <tr key={list_key(data.id)}>{cols}</tr>
        );
    }

  
    filterRecords = (data?: any) => {
        if( this.records && this.records.current !== null){
          if(data !== undefined){
            this.records.current.setFormFields(data);
          }else {
            this.records.current.setFormFields();
          }
        }
      }

    render() {


        return (
            <div>

              <ListingLayout breadcrumb={ListBreadcrumb}>
                <ListHeader title={"System Notifications"} icon={Icons.email} >
                  <ExportButton records={this.records} fileName={"System Notifications"}/>
                  &nbsp;
                  <CreateLink to={`${this.props.match.url}/create`} scope={'system-notifications.store'} />
                </ListHeader>

                <ListForm
                  form={<EmailTemplateFilter  getResults={this.filterRecords} />}
                  table={(
                    <ShowRecords
                      url={"/settings/system-notifications"}
                      showRecords={this.showContent}
                      ref={this.records}
                      isNeedAction={true}
                      showCheckbox={false}
                      actionButtons={actionButton({records: this.records, 'url': "settings/system-notifications/bulk-action"})}
                      //rowActions={this.rowActionButtons}
                    />
                  )}
                />
              </ListingLayout>

                
            </div>
        )
    }
}
